import apiUrl from "../../../../../utils/settings";

export const allStateUrl = () => {
  return apiUrl + '/onboarding/get/all-state';
};

export const allCityUrl = () => {
  return apiUrl + '/onboarding/get/all_district';
};
